// 라우트 경로 상수

export const ROUTES = {
  HOME: '/',

  // API 문서
  API_DOCS: {
    REALESTATE: '/api-docs/realestate',
    BUSINESS: '/api-docs/business',
    CARD: '/api-docs/card',
    AUTHENTICATION: '/api-docs/authentication',
  },

  // 개발자 도구
  DEVELOPER_TOOLS: {
    API_TEST: '/developer-tools/api-test',
    SANDBOX: '/developer-tools/sandbox',
    SDK: '/developer-tools/sdk',
    CODE_SAMPLES: '/developer-tools/code-samples',
  },

  // 지원
  SUPPORT: {
    GETTING_STARTED: '/support/getting-started',
    FAQ: '/support/faq',
    COMMUNITY: '/support/community',
    CONTACT: '/support/contact',
  },

  // 기타
  PRICING: '/pricing',
  DASHBOARD: '/dashboard',
  LOGIN: '/login',
  SIGNUP: '/signup',

  // 법적 문서
  TERMS: '/terms',
  PRIVACY: '/privacy',
  SECURITY: '/security',
} as const;

// 라우트 타입
export type RouteKey = typeof ROUTES[keyof typeof ROUTES];
